module.exports = __webpack_public_path__ + "static/media/animal-welfare-accountability_fr.0d2b171c.jpg";